import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import { COLOR_ENUM, SIZE_ENUM } from '@/components/@base/@types';
import CheckBox from '@/components/@base/input/check-box/toggle';
import {
  deleteFromSessionStorage,
  getFromSessionStorage,
  setToSessionStorage,
} from '@/lib/helper';
import useHomeStore from '@/store/home';


const ActiveEditWallets = () => {
  const {setIsActiveEditWallets, isActiveEditWallets} = useHomeStore()
  const handleActiveEdit = () => {
    if(getFromSessionStorage('editableWallets')) {
      deleteFromSessionStorage('editableWallets');
      setIsActiveEditWallets(false);
    } else {
      setToSessionStorage('editableWallets', 'true');
      setIsActiveEditWallets(true)
    }
  }
  return <Container className="felx flex-col p-4">
          <Text semiBold color={COLOR_ENUM.BLACK} size={SIZE_ENUM.MD} className="dark:text-white">{localization.changeAmount}</Text>
          <Text size={SIZE_ENUM.SM} className="text-grayLight-600 dark:text-grayDark-75 my-2 text-right">{localization.activationChangeAmountHint}</Text>
          <Container center className="rounded-lg bg-grayLight-50 dark:bg-grayDark-750 justify-between pr-4 py-3">
            <Text medium color={COLOR_ENUM.BLACK} size={SIZE_ENUM.MD} className="dark:text-white">{localization.canChangeAmount}</Text>
            <CheckBox checked={isActiveEditWallets} onChange={handleActiveEdit}/>
          </Container>
        </Container>
}
export default ActiveEditWallets;